<script setup lang="ts">
import QuestionnaireAnswerReview from "../parts/QuestionnaireAnswerReview.vue";
import QuestionnaireButtonNext from "../parts/QuestionnaireButtonNext.vue";
import QuestionnaireButtonPrev from "../parts/QuestionnaireButtonPrev.vue";
import QuestionnaireFinalScreen from "../parts/QuestionnaireFinalScreen.vue";
import QuestionnaireTextField from "../parts/QuestionnaireTextField.vue";
import { defineProps, ref, defineEmits } from "vue";

type Props = {
  finalTitle: string;
  finalSubtitle?: string;
  prevButtonText: string;
  nextButtonText?: string;
  doneButtonText?: string;
  textFieldTitle?: string;
  textFieldPlaceholder?: string;
  answers?: Array<{
    question: string;
    answer: string;
  }>;
  status?: string;
  isLoading: boolean;
  currentPhase: any;
};
type Emits = {
  (event: "onStepBack"): void;
  (event: "onSubmit", ibnDate: string, generateReport?: boolean): void;
};
const emits = defineEmits<Emits>();

const props = defineProps<Props>();

const ibnDate = ref("");
const ibnDateError = ref({
  isError: false,
  message: "",
});
const isSelectedCheckbox = ref();

const onSubmit = () => {
  if (props.currentPhase?.phaseId === 2 && props.textFieldTitle) {
    if (ibnDate.value && ibnDate.value.trim() !== "") {
      ibnDateError.value.isError = false;
      ibnDateError.value.message = "";
    } else {
      ibnDateError.value.isError = true;
      ibnDateError.value.message = "This field is required!";
    }
  }
  if (!ibnDateError.value.isError) {
    emits("onSubmit", ibnDate.value, isSelectedCheckbox.value);
  }
};
</script>

<template>
  <div>
    <div>
      <QuestionnaireFinalScreen
        :title="finalTitle"
        :sub-title="finalSubtitle"
        :status="status"
      />
    </div>
    <div v-if="textFieldTitle">
      <QuestionnaireTextField
        v-model="ibnDate"
        :title="textFieldTitle"
        :placeholder="textFieldPlaceholder"
        :is-error="ibnDateError.isError"
        :error-message="ibnDateError.message"
      />
      <div
        v-if="!currentPhase.hasQc"
        class="flex items-center gap-2 pt-3 pb-2 border-t border-gray-200"
      >
        <input
          type="checkbox"
          id="report"
          v-model="isSelectedCheckbox"
          :class="isSelectedCheckbox ? 'hidden' : 'block'"
        />
        <label for="report" class="flex items-center gap-2 cursor-pointer">
          <img
            v-show="isSelectedCheckbox"
            src="@/assets/checkbox-checked.svg"
            alt=""
          />
          <p
            class="text-base font-normal leading-5 tracking-[0.01rem] text-primary-text-color"
          >
            Generate report
          </p>
        </label>
      </div>
    </div>
    <div v-else-if="answers" class="">
      <QuestionnaireAnswerReview :answers="answers" />
    </div>
    <div
      class="w-full flex items-center justify-between pt-3 mt-[46px] border-t border-black/15"
    >
      <div>
        <QuestionnaireButtonPrev
          @click="$emit('onStepBack')"
          :button-text="prevButtonText"
        />
      </div>
      <div v-if="doneButtonText">
        <QuestionnaireButtonNext
          :is-loading="isLoading"
          @click="onSubmit"
          :button-text="doneButtonText"
        />
      </div>
      <div v-else-if="nextButtonText">
        <QuestionnaireButtonNext
          :is-loading="isLoading"
          :button-text="nextButtonText"
        />
      </div>
    </div>
  </div>
</template>
